"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTouchFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28.57 15.18a21.11 21.11 0 00-9.76-3.13l-1.5-7.48A3.2 3.2 0 0011 5.2V18l-1.43-1a3.84 3.84 0 00-2.71-1 5 5 0 00-3.73 2.46l-.38.6L11.5 30h7.58c5.82 0 9-2.38 9.34-7.08l.58-7.41z" })));
}
exports.default = SvgTouchFilled;
//# sourceMappingURL=TouchFilled.js.map